import { Component, ViewChild } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { WorkerZone } from '../_types/worker-zone';
import { WorkerZonesService } from '../_services/workers-zones.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ZonesService } from '../../zones/_services/zones.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { ZonesLinesService } from '../../zones/_services/zones-lines.service';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-workers-zone',
    templateUrl: './workers-zone.component.html',
    styleUrls: ['./workers-zone.component.scss'],
    standalone: false
})
export class WorkersZoneComponent {
  public workerZoneFormGroup!: RxFormGroup;

  public workerZone: WorkerZone = new WorkerZone();
  public zones: any[] = [];

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public allPostaCodesFromSelectedZone: any[] = [];

  constructor(
    private workerZonesService: WorkerZonesService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private zonesService: ZonesService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private zonesLinesService: ZonesLinesService,
    private loginService: LoginService
  ) {
    this.workerZoneFormGroup = this.formBuilder.formGroup<WorkerZone>(this.workerZone) as RxFormGroup;
  }

  ngOnInit(): void {
    if (this.config.data.workerZoneId) {
      this.loadWorkerZone(this.config.data.workerZoneId);
    } else {
      this.workerZone.workerId = this.config.data.workerId;
      this.loadZones();
    }
    this.allowWrite = this.loginService.hasPermission("WORKERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("WORKERS.DELETE");
  }

  async loadWorkerZone(id: string) {
    this.workerZone = await firstValueFrom(this.workerZonesService.get(id));
    this.workerZoneFormGroup.patchValue(this.workerZone);
        this.loadZones();

  }

  async loadZones() {
    let filters = {};
    if(this.workerZone && this.workerZone.zoneId != null){
        filters = {
          id: new Filter(FilterOperation.equals, 'id', "", this.workerZone.zoneId)
        }
      }
    let response = await firstValueFrom(this.zonesService.all({filter: FilterBuilder.fromObject(filters).build() ,page: {number: 1, size: 100}}));
    this.zones = response.data;
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.workerZoneFormGroup);
    if (valid) {
      this.workerZone = Object.assign(this.workerZone, this.workerZoneFormGroup.value);

      await this.workerZonesService.save(this.workerZone).subscribe({
        next: (data) => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Zona guardada correctamente' });
          this.dynamicDialogRef.close();
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar el servicio' });
        }
      });
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la zona?",
      header: "Eliminar zona",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerZonesService.delete(this.workerZone.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Zona eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }
  
  async onSearchZone(event: any){
    //Recargamos los datos del modelo.
    if(event != null && event.filter != null && ( event.filter.length >= 3 || event.filter.length==0)  ){
      let filter: any = { 
        name: new Filter(FilterOperation.contains, "name", "", event.filter)
      };
      let response = await firstValueFrom(this.zonesService.all({
        filter: FilterBuilder.fromObject(filter).build() ,
        page: {number: 1, size: 100}}
      ));
    this.zones = response.data;
    }
  }
  async onChangeZone(event:any){
    if(this.workerZoneFormGroup.get('zoneId')?.value ==null){
      this.workerZoneFormGroup.get('value')?.enable();
       this.allPostaCodesFromSelectedZone = [];
       this.loadZones();
    }else{
      this.workerZoneFormGroup.get('value')?.disable();
        
      //Cargamos los codigos postales de la zona seleccionada.
      let params: IParamsCollection = {
      }
      let filters: any = {
        zoneId: new Filter(FilterOperation.equals, "zoneId"),
      };
  
      filters.zoneId.value = this.workerZoneFormGroup.get('zoneId')?.value;
      params.filter = FilterBuilder.fromObject(filters).build();
      let response = await firstValueFrom(this.zonesLinesService.all(params));
      this.allPostaCodesFromSelectedZone = response.data;
    }
  }

}
